export type IconProps = {
	icon?: any;
};

export const Icon = ({ icon }: IconProps): JSX.Element => {
	const {
		icon: [x, y, a, uniCode, d],
	} = icon;
	return (
		<>
			<svg viewBox={`0 0 ${x} ${y}`}>
				<path fill="white" d={d} accentHeight={a} unicode={uniCode} />
			</svg>
		</>
	);
};
